import type { Messages } from './index'

export const en: Messages = {
  action_failed: "The action failed, please retry.",
  admin_filters: "Management",
  agent_approval_remove: "Remove agent approval",
  agent_approval_set: "Hand over to the agent",
  agent_blocked: "Agent: blocked {detail}",
  agent_capacity: " · capacity {pct}%",
  agent_idle: "Agent: idle, queue empty",
  agent_limited: "Agent: usage limit reached, resumes around {time}",
  agent_no_signal: "Agent: no heartbeat published",
  agent_route_farm: "Agent farm",
  agent_route_title: "Hand over to…",
  agent_route_tower: "Control tower",
  agent_stale: "Agent: no news (last seen at {time}), usage limit likely",
  agent_will_handle: "Will be handled by the agent",
  agent_working: "Agent: working {detail} · {queue} queued",
  anonymous: "Anonymous",
  archive: "Archive",
  archive_view_active: "Active",
  archive_view_all: "All",
  archive_view_archived: "Archived",
  archive_view_aria: "Archive view",
  archived: "Archived",
  business_context: "Context",
  cancel: "Cancel",
  close: "Close",
  comment_delete_message: "Delete this comment?",
  comment_delete_title: "Delete comment",
  comment_mention_none: "Nobody to mention",
  comment_mention_title: "Mention someone",
  comment_mentioned_label: "Mentioned: {names}",
  comment_reaction: "Reaction",
  comment_reply: "Reply",
  comment_reply_count_one: "{count} reply",
  comment_reply_count_other: "{count} replies",
  comment_reply_hide: "Hide replies",
  comment_reply_placeholder: "Reply… (⌘↵ to send)",
  comment_voice_tooltip: "Dictated to Mila, the voice agent",
  comment_edited: "(edited)",
  comment_failed: "The comment failed, please retry.",
  comment_placeholder: "Reply… (⌘↵ to send)",
  comment_placeholder_first: "Write the first comment… (⌘↵ to send)",
  comment_send: "Send",
  comments_title: "Comments",
  composer_add_title: "Add a title",
  composer_body_aria: "Description",
  composer_body_placeholder: "Details (optional) - markdown supported",
  composer_body_placeholder_feature: "Describe your idea…",
  composer_cancel: "Cancel",
  composer_cancel_confirm: "Discard this draft?",
  composer_cancel_title: "Discard draft",
  composer_cancel_yes: "Yes, discard",
  composer_continue: "Keep editing",
  composer_save: "Save",
  composer_saved: "Saved",
  composer_saving: "Saving…",
  composer_submit: "Send feedback",
  composer_submit_failed: "Send failed - try again.",
  composer_submit_sending: "Sending…",
  composer_submit_sent: "Sent",
  composer_title_aria: "Feedback title",
  composer_title_placeholder: "Feedback title",
  composer_title_placeholder_bug: "What happened?",
  composer_title_placeholder_feature: "Describe your idea in one sentence…",
  composer_title_placeholder_question: "What is your question?",
  composer_update_failed: "Update failed, please retry.",
  confirm: "Confirm",
  context_capture: "Screenshot",
  context_console_errors: "Console errors ({count})",
  context_console_include: "Include the last {count} console errors",
  context_no_capture: "None",
  context_screenshot_alt: "Screenshot",
  context_screenshot_open: "Open screenshot full screen",
  context_title: "Technical context",
  context_url: "URL",
  context_user_agent: "User-agent",
  context_viewport: "Viewport",
  delete: "Delete",
  delete_message: "Delete this feedback? An administrator can restore it.",
  delete_title: "Delete feedback",
  detail_discussion_label: "Discussion",
  duplicate_of: "Duplicate of",
  edit: "Edit",
  empty_detail: "Select a feedback in the list to see its details.",
  empty_detail_v2: "Select an item",
  empty_filtered_clear: "Clear all",
  empty_filtered_inline: "Nothing found.",
  empty_filtered_subtitle: "Try removing filters or broadening your search.",
  empty_filtered_title: "No feedback matches",
  empty_first_cta: "Create a feedback",
  empty_first_cta_bug: "Bug",
  empty_first_cta_bug_aria: "Report a bug",
  empty_first_cta_idea: "Idea",
  empty_first_cta_idea_aria: "Create a new idea",
  empty_first_cta_question: "Question",
  empty_first_cta_question_aria: "Ask a question",
  empty_first_shortcut_hint: "You can also press ⌘ + Shift + F anywhere on this site",
  empty_first_subtitle: "Ideas, bugs or questions - we read everything.",
  empty_first_subtitle_v2: "Share an idea, a bug you ran into, or a question. The team reads every message.",
  empty_first_title: "Be the first to share your thoughts ✨",
  empty_first_title_v2: "Start the conversation",
  filter_all: "All",
  filter_all_authors: "All authors",
  filter_author: "Author",
  filter_mine: "My feedbacks only",
  filter_others: "From others",
  filter_search_aria: "Search feedbacks",
  filter_search_clear: "Clear search",
  filter_search_placeholder: "Search (3 chars min.)…",
  filter_status_aria: "Filter by status",
  filter_trash: "Trash",
  filter_type_aria: "Filter by type",
  filter_unread: "Unread",
  filters_region_aria: "Filters",
  filters_reset: "Reset",
  filters_toggle: "Filters",
  handled_by_tower: "Handled by the control tower",
  history_count: "{count} edit(s)",
  history_open: "Show edit history",
  history_replaced_on: "Version replaced on {date}",
  history_title: "Edit history",
  load_error: "Loading failed",
  load_more: "Load more",
  loading: "Loading…",
  media_add: "Add media",
  media_add_button: "Add media",
  media_attached_count: "{count} attachment(s)",
  media_close_lightbox: "Close",
  media_dismiss_error: "Dismiss error",
  media_drop_hint: "or drag and drop",
  media_max_reached: "Maximum {max} files",
  media_open_lightbox: "Open fullscreen",
  media_open_original: "Open original",
  media_open_pdf: "Open PDF",
  media_remove: "Remove this media",
  media_too_large: "{name} exceeds the 10 MB limit.",
  media_unsupported_type: "Unsupported type: {type}",
  media_upload_failed: "Upload failed - try again.",
  media_uploading: "Uploading {name}…",
  modal_back: "Back",
  modal_close: "Close",
  modal_filters_active_aria: "Active filters",
  modal_new: "New",
  modal_new_aria: "New feedback",
  modal_title: "Feedbacks",
  next: "Next",
  not_found: "Feedback not found",
  preview_close: "Close preview",
  preview_title: "Existing feedback",
  previous: "Previous",
  relative_now: "just now",
  retry: "Retry",
  save: "Save",
  screenshot_attach: "Attach a screenshot",
  screenshot_attached_alt: "Attached screenshot",
  screenshot_capturing: "Capturing…",
  screenshot_failed: "Capture failed",
  screenshot_remove: "Remove screenshot",
  screenshot_target_missing: "Target element not found.",
  screenshot_view: "View screenshot full screen",
  search_toggle: "Search",
  similar_aria: "Similar feedbacks",
  similar_declined: "declined {since}",
  similar_duplicate: "duplicate {since}",
  similar_posted: "posted {since}",
  similar_shipped: "shipped {since}",
  similar_title: "Already exists?",
  sort_aria: "Sort feedback",
  sort_comments: "Most discussed",
  sort_recent: "Recent",
  sort_score: "Votes",
  sort_updated: "Updated",
  source_academy: "Academy",
  source_ai: "AI",
  source_caast: "Caast sync",
  source_cli: "Command line",
  source_mcp: "MCP",
  source_phone: "Dictated by phone",
  source_voice: "Dictated",
  status_active: "Active",
  status_change_aria: "Status: {label}, change",
  status_declined: "Declined",
  status_duplicate: "Duplicate",
  status_in_progress: "In progress",
  status_on_hold: "On hold",
  status_open: "Open",
  status_planned: "Planned",
  status_shipped: "Shipped",
  status_under_review: "Under review",
  trigger_aria_open: "Open Feedbacks",
  trigger_aria_open_desktop: "Open Feedbacks (shortcut ⌘+Shift+F)",
  trigger_unread: "Open feedback: {count} unread",
  type_bug: "Bug",
  type_bug_hint: "Something is wrong",
  type_bugs: "Bugs",
  type_feature: "Idea",
  type_feature_hint: "New feature",
  type_features: "Ideas",
  type_legend: "Feedback type",
  type_question: "Question",
  type_question_hint: "I have a doubt",
  type_questions: "Questions",
  unarchive: "Unarchive",
  unread: "Unread",
  unread_comments: "Unread comments",
  vote_down: "Downvote",
  vote_down_remove: "Remove downvote",
  vote_failed: "The vote failed, please retry.",
  vote_up: "Upvote",
  vote_up_remove: "Remove upvote",
  typing_many: "{names} are typing…",
  typing_one: "{name} is typing…",
}
